<div class="group max-w-[120px] cursor-pointer" [routerLink]="link">
  <h3 class="text-3xl text-gray-500 sm:text-2xl xs:text-xl">
    <ng-container *ngIf="!loading; else showLoader">
      {{ count || '-' }}
    </ng-container>
    <ng-template #showLoader>
      <dib-dot-loader size="small" color="current"></dib-dot-loader>
    </ng-template>
  </h3>

  <a class="text-sm font-medium text-emerald-600 group-hover:underline sm:text-xs">{{ title }}</a>
</div>
